<template>
  <v-menu offset-y left max-height="500px" max-width="300px">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        icon color="primary"
        :disabled="updateNotificationsPending || fetchNotificationsPending"
        :loading="updateNotificationsPending || fetchNotificationsPending"
      >
        <v-badge color="red" overlap :value="countNotifications > 0">
          <span slot="badge">{{ countNotifications }}</span>
          <v-icon>notifications</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list two-line class="pa-0">
      <v-list-item class="py-0" v-if="countNotifications > 0">
        <v-subheader class="pl-0">{{ $t('texts.newNotifications') }}</v-subheader>
        <v-spacer/>
        <v-tooltip color="info" left>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon small @click="updateAllNotificationsRead()">
              <v-icon>done_all</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('texts.allNotificationsRead') }}</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item
        v-for="notification in openNotifications"
        :key="notification.id"
        @click="update(notification.id, notification.company_id, notification.type)"
      >
        <v-list-item-action>
          <v-icon>{{ notificationIcon(notification.company_id, notification.type) }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <span class="body-2">{{ notification.message }}</span><br>
          <span class="caption">{{ notification.created_at | formatTimestamp }}</span>
        </v-list-item-content>
      </v-list-item>
      <template v-if="notifications.length - countNotifications > 0">
        <v-list-item class="py-0">
          <v-subheader class="py-0">{{ $t('texts.oldNotifications') }}</v-subheader>
        </v-list-item>
        <v-list-item
          v-for="notification in readNotifcations"
          :key="notification.id"
          @click="goToEventPage(notification.company_id, notification.type)"
        >
          <v-list-item-action>
            <v-icon>{{ notificationIcon(notification.type) }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <span class="body-2">{{ notification.message }}</span><br>
            <span class="caption">{{ notification.created_at | formatTimestamp }}</span>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list-item v-if="notifications.length === 0">
        <v-list-item-content>
          <v-list-item-title class="body-1">
            {{ $t('texts.noNotifications') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');
const { mapActions: mapCompanyActions } = createNamespacedHelpers('company');

export default {
  name: 'Notifications',
  computed: {
    ...mapUserState([
      'language',
      'fetchNotificationsPending',
      'updateNotificationsPending',
      'notifications',
    ]),
    openNotifications() {
      return this.notifications.filter((notification) => notification.read_at === null);
    },
    readNotifcations() {
      return this.notifications.filter((notification) => notification.read_at !== null);
    },
    countNotifications() {
      return this.openNotifications.length;
    },
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
  },
  methods: {
    ...mapUserActions([
      'updateNotification',
      'updateAllNotificationsRead',
    ]),
    ...mapCompanyActions([
      'fetchCompanies',
    ]),
    notificationIcon(companyId, type) {
      if (companyId === null) {
        switch (type) {
          case 'ApplicationReceived': {
            return 'description';
          }
          case 'ApplicationOpenReminder': {
            return 'description';
          }
          case 'CompanyLinkedToResumeJob': {
            return 'compare_arrows';
          }
          default: {
            return 'description';
          }
        }
      } else {
        switch (type) {
          case 'CooperationAgreementChanged': {
            return 'description';
          }
          case 'ResumeJobEntryChanged': {
            return 'description';
          }
          default: {
            return 'description';
          }
        }
      }
    },
    goToEventPage(companyId, type) {
      if (companyId !== null) {
        switch (type) {
          case 'ApplicationReceived': {
            this.$router.push({ path: `/company/${companyId}/applications/ongoing` });
            break;
          }
          case 'ApplicationOpenReminder': {
            this.$router.push({ path: `/company/${companyId}/applications/ongoing` });
            break;
          }
          case 'CompanyLinkedToResumeJob': {
            this.$router.push({ path: `/company/${companyId}/employees/assignment` });
            break;
          }
          default: {
            this.$router.push({ path: `/company/${companyId}/applications/ongoing` });
            break;
          }
        }
      } else {
        switch (type) {
          case 'CooperationAgreementChanged': {
            this.$router.push({ path: '/employee/cooperation-agreements' });
            break;
          }
          case 'ResumeJobEntryChanged': {
            this.$router.push({ path: '/employee/documents' });
            break;
          }
          default: {
            this.$router.push({ path: '/employee/documents' });
            break;
          }
        }
      }
      return '';
    },
    update(id, companyId, type) {
      this.updateNotification(id)
        .then(() => {
          this.goToEventPage(companyId, type);
          if (companyId > 0) {
            this.fetchCompanies();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-list__tile {
      background: #ffffff;
      height: auto;
      padding-top: 12px;
      padding-bottom: 12px;
    }
    .v-list__tile__title {
      white-space: normal;
      height: auto;
    }
  }
</style>
